import React, { useState, useEffect } from "react";
import TransactionResult from "./TransactionResult";
// import CustomScrollbar from "../../shared/CustomScrollbar";
import {
  TransactionsHead,
  TransactionsDate,
  LoadMoreMain,
} from "./styles/TransactionsPaidStyle";
import Loader from "../../shared/loader";
import { TRANSACTIOS } from "../../../constants/apiEndPoints";
import httpRequest from "../../../axios/index";
import { toast } from "react-hot-toast";
import { Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { CustomScrollbarStyle } from "../messages/styles/ScrollbarStyles";
import MainButton from "../../shared/Button";
import NotFoundIcon from "../../shared/NotFoundIcon";

const TransactionsPaid = () => {
  const { user: useInfo = {} } = useSelector((state) => state.auth);

  const [Loading, setLoading] = useState(false);
  const [TransactionsData, SetTransactionsData] = useState([]);
  const [TransactionsAllData, SetTransactionsAllData] = useState([]);
  const [Page, setPage] = useState(1);
  const [IsLastPage, setIsLastPage] = useState(null);
  const [loadingMore, setLoadingMore] = useState(false);

  const scrollbarHeight = "75vh";

  useEffect(() => {
    GetAllTransactions();
  }, [Page]);

  const GetAllTransactions = async () => {
    let param = `&page=${Page}`;
    try {
      if (Page === 1) {
        setLoading(true);
      } else {
        setLoadingMore(true);
      }
      const resp = await httpRequest.get(`${TRANSACTIOS}?type=paid${param}`);
      if (resp?.status === 200) {
        setIsLastPage(resp?.data?.last_page);
        if (resp?.data.message === "Success") {
          SetTransactionsData(resp?.data);
          if (Page === 1) {
            SetTransactionsAllData(resp?.data?.data?.data);
          } else {
            SetTransactionsAllData((prevData) => [
              ...prevData,
              ...resp?.data?.data?.data,
            ]);
          }
        }
      }
      setLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      setLoading(false);
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };
  const handlePagination = () => {
    setPage((prevPage) => prevPage + 1);
  };

  return (
    <>
      {Loading && <Loader />}
      {!Loading && (
        <>
          {useInfo &&
            useInfo?.user_type &&
            useInfo?.user_type === "business" && (
              <>
                <TransactionsHead>
                  <div className="head_main">
                    <div className="head_text">
                      <h6>Due balance</h6>
                      <span className="due_date">
                        Your payment is due in next{" "}
                        {TransactionsData?.data?.due_at} days
                      </span>
                    </div>
                    <div className="head_price">
                      <span>${TransactionsData?.data?.amount}</span>
                      <span className="due_date">
                        Your payment is due in next{" "}
                        {TransactionsData?.data?.due_at} days
                      </span>
                    </div>
                  </div>
                </TransactionsHead>
                <TransactionsDate>
                  <span> {TransactionsData?.data?.date_range}</span>
                </TransactionsDate>
              </>
            )}
        </>
      )}

      <CustomScrollbarStyle scrollbarHeight={scrollbarHeight}>
        {!Loading && TransactionsAllData && TransactionsAllData?.length > 0
          ? TransactionsAllData?.map((items) => {
              return (
                <TransactionResult status="Paid" key={items?.id} Data={items} />
              );
            })
          : !Loading && <NotFoundIcon MT="20" />}
        {!Loading && !IsLastPage && TransactionsAllData?.length > 0 && (
          <LoadMoreMain>
            <MainButton
              type="button"
              label="Load More"
              isLoading={loadingMore}
              MT="0"
              onClick={handlePagination}
            />
          </LoadMoreMain>
        )}
      </CustomScrollbarStyle>
    </>
  );
};

export default TransactionsPaid;
